import type { FeatureAdoption } from '@floorpoll/shared';

/** Sorted most to least adopted — a magnitude comparison is ordered by magnitude. */
export function AdoptionBars({ adoption }: { adoption: FeatureAdoption[] }) {
  if (adoption.length === 0) return <p className="muted">Nothing to measure yet.</p>;

  const sorted = [...adoption].sort((a, b) => b.percentage - a.percentage);

  return (
    <div className="adopt">
      {sorted.map((entry) => (
        <div className="adopt-row" key={entry.key}>
          <span>{entry.label}</span>
          <div
            className="adopt-track"
            role="meter"
            aria-valuenow={entry.percentage}
            aria-valuemin={0}
            aria-valuemax={100}
            aria-label={`${entry.label}: ${entry.numerator} of ${entry.denominator}`}
          >
            <span className="adopt-fill" style={{ width: `${entry.percentage}%` }} />
          </div>
          <span className="adopt-pct">{entry.percentage}%</span>
        </div>
      ))}
    </div>
  );
}
